<mat-drawer-container class="bg-transparent h-screen w-full overflow-hidden">
    <mat-drawer
        class="w-full overflow-hidden z-20 md:w-160 dark:bg-gray-900 border-none md:bg-white/610 md:backdrop-blur-sm   bg-white/10 backdrop-blur-md"
        [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="true" #matDrawer>
        <div class="mt-16"></div>
        <div class=" bg-transparent text-slate-600/10 lg:block pointer-events-none">
            <svg class="absolute inset-0 h-full w-full  [mask-image:linear-gradient(to_top,white,transparent)]"
                xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <pattern id="all-access-grid-pattern" width="32" height="32" patternUnits="userSpaceOnUse" x="50%"
                        y="100%" patternTransform="translate(0 -1)">
                        <path d="M0 32V.5H32" fill="none" stroke="currentColor"></path>
                    </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#all-access-grid-pattern)"></rect>
            </svg>
        </div>
        <div class="safe-container">
            <ng-content select="[drawer]"></ng-content>
        </div>
    </mat-drawer>

    <mat-drawer-content>

        <div class="safe-container">

            <!-- Header Wrapper -->
            <div class="flex flex-col w-full min-h-50  mx-auto  px-3 sm:px-8 ">

                <div class="flex flex-col sm:flex-row flex-auto sm:items-center min-w-0  my-8 sm:my-10">

                    <!-- Title-->
                    <div class="flex flex-auto items-center min-w-0">

                        <!-- Custom -->
                        <ng-content select="[header]" *ngIf="customHeader else builtInHeader"></ng-content>

                        <!-- Built-in -->
                        <ng-template #builtInHeader>
                            <fa-icon [icon]="icon" size="4x"></fa-icon>
                            <div class="flex flex-col min-w-0 ml-4">
                                <ng-container>
                                    <div
                                        class="text-2xl md:text-5xl  font-semibold tracking-tight leading-7 md:leading-snug truncate">
                                        {{title}}
                                    </div>
                                </ng-container>
                                <div class="flex items-center">
                                    <div class="leading-6 truncate text-secondary">
                                        {{description}}
                                    </div>
                                </div>
                            </div>
                        </ng-template>

                    </div>


                    <!-- Actions -->
                    <div class="mt-6 flex w-full flex-col gap-3 sm:mt-0 sm:ml-6 sm:w-auto sm:flex-row sm:items-center">

                        <!-- Custom -->
                        <ng-content select="[headerAction]" *ngIf="customHeaderAction else builtInHeaderAction">
                        </ng-content>

                        <!-- Built-in -->
                        <ng-template #builtInHeaderAction>
                            <!-- Search -->
                            <div class="w-full sm:w-96">

                                <mat-form-field class="w-full min-w-0 frosty" subscriptSizing="dynamic">
                                    <mat-icon class="icon-size-4" matPrefix [svgIcon]="'fal:search'"></mat-icon>

                                    <input matInput [formControl]="searchControl" [(ngModel)]="searchTerm"
                                        [autocomplete]="'off'"
                                        placeholder="{{'SystemAdmin.Components.ListPageBase.Header.RightSide.Search' | translate}}">

                                </mat-form-field>

                            </div>
                            <!-- Add button -->
                            <ng-container *ngIf="!hideAdd">
                                <button *ngIf="!addButtonMenu; else addMenuButton" class="h-10 min-h-10 frosty px-4"
                                    mat-flat-button (click)="newItemClick.next()" [disabled]="disableAdd">
                                    <mat-icon [svgIcon]="'far:plus'" class="icon-size-4"></mat-icon>
                                    <span class="ml-2 mr-1">{{'SystemAdmin.Components.ListPageBase.Header.RightSide.Add' |
                                        translate}}</span>
                                </button>

                                <ng-template #addMenuButton>
                                    <button class="h-10 min-h-10 frosty px-4" mat-flat-button [matMenuTriggerFor]="addMenu">
                                        <mat-icon [svgIcon]="'far:plus'" class="icon-size-4"></mat-icon>
                                        <span class="ml-2 mr-1">{{'SystemAdmin.Components.ListPageBase.Header.RightSide.Add' |
                                            translate}}</span>
                                        <fa-icon [icon]="['fas', 'chevron-down']" class="-mr-1 ml-2 text-sm"></fa-icon>
                                    </button>
                                    <mat-menu #addMenu="matMenu">
                                        <button mat-menu-item (click)="newItemClick.next()" [disabled]="disableAdd">
                                            <fa-icon [icon]="['fal', 'plus']" class="mr-2"></fa-icon>
                                            <span>{{'SystemAdmin.Components.ListPageBase.Header.RightSide.Add' |
                                                translate}}</span>
                                        </button>
                                        <ng-content select="[addMenuItem]"></ng-content>
                                    </mat-menu>
                                </ng-template>
                            </ng-container>


                        </ng-template>
                    </div>
                </div>
                <!-- View selector -->

                <div [class.invisible]="supportedViewCount<=1"
                    class="relative flex self-start py-1 px-2 cursor-pointer overflow-hidden frosty-base text-sm"
                    matRipple>
                    <div class="flex items-center" [matMenuTriggerFor]="projectsMenu"
                        *ngIf="supportedViewCount>1;else singleViewSupportTemplate">

                        <div class="overflow-hidden">
                            <div class="font-medium leading-6 truncate">
                                <div class="flex items-center justify-center" [ngSwitch]="currentView">
                                    <ng-container *ngSwitchCase="viewTypes.pivot">
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:table-pivot'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.PivotView'
                                        | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.card">
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:grid-2'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.CardView'
                                        | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.history">
                                        <mat-icon class="icon-size-4 mr-2" [svgIcon]="'fal:rectangle-history'">
                                        </mat-icon>
                                        {{'SystemAdmin.Components.ListPageBase.Views.HistoryView' | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.settings">
                                        <mat-icon class="icon-size-4 mr-2" [svgIcon]="'fal:gear'">
                                        </mat-icon>
                                        {{'SystemAdmin.Components.ListPageBase.Views.SettingsView' | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:table'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.TableView'
                                        | translate}}
                                    </ng-container>

                                </div>
                            </div>
                        </div>

                        <div class="flex items-center justify-center pl-2">
                            <mat-icon class="icon-size-4" [svgIcon]="'fal:chevron-down'"></mat-icon>
                        </div>
                    </div>
                    <ng-template #singleViewSupportTemplate>
                        <div class="overflow-hidden ">
                            <div class="font-medium leading-6 truncate">
                                <div class="flex items-center justify-center" [ngSwitch]="currentView">
                                    <ng-container *ngSwitchCase="viewTypes.pivot">
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:table-pivot'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.PivotView'
                                        | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.card">
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:grid-2'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.CardView'
                                        | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.history">
                                        <mat-icon class="icon-size-4 mr-2" [svgIcon]="'fal:rectangle-history'">
                                        </mat-icon>
                                        {{'SystemAdmin.Components.ListPageBase.Views.HistoryView' | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchCase="viewTypes.settings">
                                        <mat-icon class="icon-size-4 mr-2" [svgIcon]="'fal:gear'">
                                        </mat-icon>
                                        {{'SystemAdmin.Components.ListPageBase.Views.SettingsView' | translate}}
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <mat-icon class="icon-size-4 mr-2"
                                            [svgIcon]="'fal:table'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.TableView'
                                        | translate}}
                                    </ng-container>

                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <mat-menu #projectsMenu="matMenu" [xPosition]="'before'">
                        <button mat-menu-item (click)="changeView(viewTypes.table)"
                            *ngIf="isViewSupported(viewTypes.table)">
                            <mat-icon class="icon-size-4"
                                [svgIcon]="'fal:table'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.TableView'
                            | translate}}
                        </button>
                        <button mat-menu-item (click)="changeView(viewTypes.pivot)"
                            *ngIf="isViewSupported(viewTypes.pivot)">
                            <mat-icon class="icon-size-4"
                                [svgIcon]="'fal:table-pivot'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.PivotView'
                            | translate}}
                        </button>
                        <button mat-menu-item (click)="changeView(viewTypes.card)"
                            *ngIf="isViewSupported(viewTypes.card)">
                            <mat-icon class="icon-size-4"
                                [svgIcon]="'fal:grid-2'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.CardView'
                            | translate}}
                        </button>
                        <button mat-menu-item (click)="changeView(viewTypes.history)"
                            *ngIf="isViewSupported(viewTypes.history)">
                            <mat-icon class="icon-size-4"
                                [svgIcon]="'fal:rectangle-history'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.HistoryView'
                            | translate}}
                        </button>
                        <mat-divider *ngIf="isViewSupported(viewTypes.settings)"></mat-divider>
                        <button mat-menu-item (click)="changeView(viewTypes.settings)"
                            *ngIf="isViewSupported(viewTypes.settings)">
                            <mat-icon class="icon-size-4"
                                [svgIcon]="'fal:gear'"></mat-icon>{{'SystemAdmin.Components.ListPageBase.Views.SettingsView'
                            | translate}}
                        </button>
                    </mat-menu>
                </div>

            </div>


            <!-- Header Divider -->
            <div class="relative  w-auto h-1 rounded-sm mx-2 mt-2 bg-white/50 backdrop-blur-sm"></div>
            <!-- Main -->
            <div class="flex-auto pt-4 sm:pt-6 overflow-visible">
                <div class="w-full mx-auto ">

                    <!-- Content -->
                    <div class="flex flex-col flex-auto px-2 sm:px-8 py-1  ">
                        <ng-container [ngSwitch]="currentView">
                            <ng-content *ngSwitchCase="viewTypes.pivot" select="[pivotContent]"></ng-content>
                            <ng-content *ngSwitchCase="viewTypes.card" select="[cardContent]"></ng-content>
                            <ng-content *ngSwitchCase="viewTypes.history" select="[historyContent]"></ng-content>
                            <ng-content *ngSwitchCase="viewTypes.settings" select="[settingsContent]"></ng-content>
                            <ng-content *ngSwitchDefault select="[tableContent]"></ng-content>
                        </ng-container>

                    </div>

                </div>
            </div>
        </div>
    </mat-drawer-content>

</mat-drawer-container>
